import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Main from './views/Main';
import Header from './views/Header';
import Inquiry from './views/Inquiry';
import Footer from './views/Footer';
import Download from './views/Download';
import Notice from './views/Notice';
import Login from './views/admin/login';
import AdminInquiry from './views/admin/inquiry';
import { CustomAlretDialog } from './views/Components/Dialog';
import NoticeDetail from './views/NoticeDetail';
import PrivacyTerms from './views/Terms/PrivacyTerms';
import ServiceTerms from './views/Terms/ServiceTerms';
import LocationTerms from './views/Terms/LocationTerms';


export const Routers = () => {
  return (
    <Router>
      <RoutesWithHeaderAndFooter />
    </Router>
  );
};

const RoutesWithHeaderAndFooter = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isAdminRoute = location.pathname.startsWith('/admin');


  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');

  const showDialog = (message) => {
    setDialogMessage(message);
    setDialogOpen(true);
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  useEffect(() => {

    // 페이지 이동 시 스크롤을 맨위로 초기화
    window.scrollTo(0, 0);

    // 섹션에 저장된 토큰 정보 가져오기
    const token = sessionStorage.getItem('gonggam-accessToken');
    if (location.pathname === '/admin') {
      // '/admin' 경로로 접근했을 때 무조건 /admin/login으로 리다이렉트
      navigate('/admin/login', { replace: true });
    }

    if (location.pathname.startsWith('/admin/inquiry')) {
      if (!token) {
        showDialog('세션이 만료되었습니다. 다시 로그인을 해주세요');
        // 토큰이 없으면 /admin/login으로 리다이렉트
        navigate('/admin/login', { replace: true });
      }
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    // PWA 설치 프롬프트 이벤트 감지
    const handler = (e) => {
      window._deferredPrompt = e; // window 내장 객체에 저장
    };

    // // beforeinstallprompt  :  웹사이트가  사용자에게 설 설치 안내를 제공할 수 있고, 설치 프로세를 생략할 수도 있게하기위한 이벤트
    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, [])
  return (
    <>
      {!isAdminRoute && <Header />} {/* admin 경로가 아니면 Header 렌더링 */}
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/inquiry" element={<Inquiry />} />
        <Route path="/inquiry/:category" element={<Inquiry />} />
        <Route path="/download" element={<Download />} />
        <Route path="/download/:category" element={<Download />} />
        <Route path="/notice" element={<Notice />} />
        <Route path="/notice/detail" element={<NoticeDetail />} />
        <Route path="/ServiceTerms" element={<ServiceTerms />} />
        <Route path="/PrivacyTerms" element={<PrivacyTerms />} />
        <Route path="/LocationTerms" element={<LocationTerms />} />
        <Route path="/admin/login" element={<Login />} />
        <Route path="/admin/inquiry" element={sessionStorage.getItem('gonggam-accessToken') ? <AdminInquiry /> : <></>} />
        {/* <Route path="/admin/inquiry" element={<AdminInquiry />} /> */}
      </Routes>
      {!isAdminRoute && <Footer />} {/* admin 경로가 아니면 Footer 렌더링 */}

      <CustomAlretDialog
        open={dialogOpen}
        message={dialogMessage}
        close={handleDialogClose}
      />
    </>
  );
};
